import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSEO, usePageView } from "../lib/seo";

export default function PaymentCancel() {
  useSEO({ title: "Checkout cancelled — The Nanny Sleep Co.", description: "No charge was made." });
  usePageView("/payment/cancel");

  return (
    <section className="max-w-2xl mx-auto px-4 sm:px-6 py-24 sm:py-32 text-center" data-testid="payment-cancel-page">
      <h1 className="font-serif font-light text-4xl sm:text-5xl text-ink mb-5">No worries — nothing was charged.</h1>
      <p className="text-lg text-ink-soft leading-relaxed max-w-md mx-auto mb-9">
        The guide will be right there whenever you're ready. And if you'd rather talk first, the suitability call is always free.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/support-options" data-testid="cancel-back-link" className="btn-primary"><ArrowLeft className="w-4 h-4" /> Back to support options</Link>
        <Link to="/book-a-call" data-testid="cancel-book-link" className="btn-secondary">Book a free call instead</Link>
      </div>
    </section>
  );
}
